import { render, staticRenderFns } from "./GeckoCmsIntegration.pug?vue&type=template&id=3312dde4&lang=pug&external"
import script from "./GeckoCmsIntegration.js?vue&type=script&lang=js&external"
export * from "./GeckoCmsIntegration.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports